export const ADDON_ITEM_KIND = {
  ADDON: 'addon',
  OTHER: 'other'
};

export const ADDON_PRICING_UNITS = {
  PER_PERSON: 'per_person',
  PER_NUMBER: 'per_number',
  PER_HOUR: 'per_hour',
  PER_EVENT: 'per_event'
};

export const OTHER_PRICING_UNIT_OPTIONS = [
  { value: ADDON_PRICING_UNITS.PER_NUMBER, label: 'Per number' },
  { value: ADDON_PRICING_UNITS.PER_HOUR, label: 'Per hour' },
  { value: ADDON_PRICING_UNITS.PER_EVENT, label: 'Per event' }
];

export const normalizePricingUnit = (value, { itemKind } = {}) => {
  const token = String(value || '').trim().toLowerCase();
  if (token === 'per_person' || token === 'person') return ADDON_PRICING_UNITS.PER_PERSON;
  if (token === 'per_hour' || token === 'hour' || token === 'hours') return ADDON_PRICING_UNITS.PER_HOUR;
  if (token === 'per_event' || token === 'event' || token === 'flat') return ADDON_PRICING_UNITS.PER_EVENT;
  if (token === 'per_number' || token === 'number' || token === 'each' || token === 'unit') {
    return ADDON_PRICING_UNITS.PER_NUMBER;
  }
  return itemKind === ADDON_ITEM_KIND.OTHER
    ? ADDON_PRICING_UNITS.PER_NUMBER
    : ADDON_PRICING_UNITS.PER_PERSON;
};

export const isOtherAddonItem = (item) => {
  const kind = String(item?.item_kind || item?.itemKind || '').toLowerCase();
  if (kind === ADDON_ITEM_KIND.OTHER) return true;
  const unit = normalizePricingUnit(item?.pricing_unit || item?.pricingUnit, { itemKind: kind });
  return kind !== ADDON_ITEM_KIND.ADDON && unit !== ADDON_PRICING_UNITS.PER_PERSON && Boolean(item?.pricing_unit || item?.pricingUnit);
};

export const getAddonPricingUnit = (item) =>
  normalizePricingUnit(item?.pricing_unit || item?.pricingUnit, {
    itemKind: item?.item_kind || item?.itemKind || (isOtherAddonItem(item) ? ADDON_ITEM_KIND.OTHER : ADDON_ITEM_KIND.ADDON)
  });

export const getAddonUnitLabel = (item) => {
  const unit = getAddonPricingUnit(item);
  if (unit === ADDON_PRICING_UNITS.PER_HOUR) return '/ hour';
  if (unit === ADDON_PRICING_UNITS.PER_EVENT) return '/ event';
  if (unit === ADDON_PRICING_UNITS.PER_NUMBER) return 'each';
  return '/ person';
};

export const getAddonQuantityNoun = (item) => {
  const unit = getAddonPricingUnit(item);
  if (unit === ADDON_PRICING_UNITS.PER_HOUR) return 'hours';
  if (unit === ADDON_PRICING_UNITS.PER_EVENT) return 'events';
  return 'quantity';
};

export const resolveAddonLineTotal = (unitPrice, quantity) => {
  const price = Number(unitPrice) || 0;
  const qty = Number(quantity) || 0;
  return Math.round(price * qty * 100) / 100;
};
